module.exports = __webpack_public_path__ + "img/newtype.8be91089.png";